/**
 * Take an ugly name provided by the backend turn it into something nicer.
 * @param name Name with underscores.
 * @returns    Nicer name.
 *
 * @example
 * // Returns "Handling Time"
 * formatUnderScoreName("handling_time");
 */
export const formatUnderscoreName = (name: string): string => {
    const words = name
        .split(/[_ ]/g)
        .filter((word) => word) // clear any empty strings resulted from split
        .map((word) => word[0].toUpperCase().concat(word.substr(1).toLowerCase()));
    return words.join(" ");
};
